import {QUERY_PARAM_REGISTRY} from '@src/hooks/queryParams/registry.ts';
import {createSerializer, parseAsString, useQueryStates} from 'nuqs';

export const IMPERSONATION_URL_KEYS = {
  impersonatedUserId: QUERY_PARAM_REGISTRY.impersonatedUserId,
  impersonatedProjectId: QUERY_PARAM_REGISTRY.impersonatedProjectId,
} as const;

const parsers = {
  impersonatedUserId: parseAsString,
  impersonatedProjectId: parseAsString,
};

const options = {
  shallow: false,
  urlKeys: IMPERSONATION_URL_KEYS,
};

export const serialize = createSerializer(parsers, options);

const useImpersonationParams = () => {
  const [{impersonatedUserId, impersonatedProjectId}, setImpersonationParams] =
    useQueryStates(parsers, options);

  return {
    impersonatedUserId,
    impersonatedProjectId,
    setImpersonationParams,
  };
};

export default useImpersonationParams;
